@if (isPlanningDisplay()) {
    <div class="flex flex-col gap-4 w-full pl-3">
        <app-field-intervention-details
            [description]="description()"
            [isFlexRow]="isFlexRow()"
            [scheduledEndDate]="fieldInterventionBloc.value()?.scheduledEndDate ?? null" />

        @if (showContextLayers()) {
            <app-field-intervention-context-layers
                class="w-full min-w-[10rem]"
                [contextLayersOptions]="contextLayersOptions()"
                [contextLayersSelected]="contextLayersSelected()"
                [displayMode]="FieldInterventionContextLayersDisplayModeEnum.EDITABLE"
                (selectionChange)="contextLayersSelectionChange.emit($event)" />
        }
    </div>
} @else {
    <div
        class="gap-4 flex w-full pl-3"
        [class.flex-col]="!isFlexRow()"
        [class.sm\:flex-row]="isFlexRow()">
        <app-field-intervention-details
            [description]="description()"
            [isFlexRow]="isFlexRow()"
            [scheduledEndDate]="fieldInterventionBloc.value()?.scheduledEndDate ?? null" />

        @if (showContextLayers()) {
            <app-field-intervention-context-layers
                class="w-1/2 min-w-[10rem] pl-5"
                [contextLayersSelected]="contextLayersSelected()"
                [displayMode]="FieldInterventionContextLayersDisplayModeEnum.READONLY" />
        }
    </div>
}
